import { render, staticRenderFns } from "./test_list.vue?vue&type=template&id=53ce7de2&scoped=true"
import script from "./test_list.vue?vue&type=script&lang=js"
export * from "./test_list.vue?vue&type=script&lang=js"
import style0 from "./test_list.vue?vue&type=style&index=0&id=53ce7de2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce7de2",
  null
  
)

export default component.exports